import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
  Typography,
} from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';

interface SuccessDialogProps {
  open: boolean;
  title?: string;
  message: string;
  buttonText?: string;
  onClose: () => void;
}

const SuccessDialog: React.FC<SuccessDialogProps> = ({
  open,
  title = 'Operação Concluída',
  message,
  buttonText = 'FECHAR',
  onClose,
}) => {
  return (
    <Dialog open={open} fullWidth maxWidth='md'>
      <DialogTitle sx={{ textAlign: 'center' }}>
        <CheckCircleIcon sx={{ color: '#4CAF50', fontSize: 60 }} />
        <Typography sx={{ fontSize: '24px', marginTop: '20px' }}>
          {title}
        </Typography>
      </DialogTitle>
      <DialogContent>
        <DialogContentText sx={{ textAlign: 'center' }}>
          {message}
        </DialogContentText>
      </DialogContent>
      <DialogActions sx={{ justifyContent: 'center', marginBottom: '30px' }}>
        <Button
          variant='contained'
          onClick={onClose}
          sx={{
            backgroundColor: '#0048B6',
            '&:hover': { backgroundColor: '#0048B6' },
          }}
        >
          {buttonText}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default SuccessDialog;
